import React from "react";
import { Props } from "./types";
import styles from "./styles.scss";
import { useTranslation } from "react-i18next";

function ExportButton({ click }: Props) {
  const { t } = useTranslation();

  return (
    <button className={styles.exportButton} onClick={click}>
      <svg className={styles.icon} viewBox="0 0 23.57 20.953">
        <path d="M15.715,4.989a.979.979,0,0,0-.286-.692L11.422.286a.981.981,0,0,0-.7-.286h-.25V5.238h5.238ZM23.368,12.6,19.451,8.66a.656.656,0,0,0-1.121.462v2.664H15.711v2.619H18.33v2.668a.656.656,0,0,0,1.121.462l3.916-3.949A.7.7,0,0,0,23.368,12.6ZM7.857,13.751v-1.31a.657.657,0,0,1,.655-.655h7.2V6.548H10.149a.985.985,0,0,1-.982-.982V0H.982A.98.98,0,0,0,0,.982V19.971a.98.98,0,0,0,.982.982H14.733a.98.98,0,0,0,.982-.982V14.405h-7.2A.657.657,0,0,1,7.857,13.751Z" />
      </svg>
      <p className={styles.text}>
        {t("projectPage.documentsPage.reportsPage.export")}
      </p>
    </button>
  );
}

export { ExportButton };
